// **********************************************************
// Testimonial Slider
// **********************************************************

const testimonialSlider = document.querySelectorAll('[data-slider="testimonial-slider"]');

const testimonialSliderOptions = {
  slidesPerView: 1,
  spaceBetween: 20,
  speed: 1000,
  watchOverflow: true,
  autoHeight: true,
  effect: 'fade',
  fadeEffect: {
    crossFade: true,
  },
  autoplay: {
    delay: 4000,
    disableOnInteraction: false,
  },
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
  breakpoints: {
    1023: {
      autoHeight: false,
    },
  },
};

testimonialSlider.forEach((el) => {
  const testimonialParent = el.closest('.testimonial-slider');
  const slides = testimonialParent.querySelectorAll('.swiper-slide');
  const navigationEle = testimonialParent.querySelector('.slider-navigation');

  const arrowRight = testimonialParent.querySelector('.arrow-right');
  const arrowLeft = testimonialParent.querySelector('.arrow-left');

  testimonialSliderOptions.navigation.nextEl = arrowRight;
  testimonialSliderOptions.navigation.prevEl = arrowLeft;

  if (slides.length <= 1) {
    navigationEle.classList.add('hide');
  }

  new Swiper(el, testimonialSliderOptions);
});
